(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory(require("vue"));
	else
		root["index"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb152");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0077":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "02f1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var classof = __webpack_require__("7ec8");

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ "07fd":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("725c");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "0950":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var call = __webpack_require__("3b34");
var isCallable = __webpack_require__("3c61");
var isObject = __webpack_require__("7d3f");

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "0c91":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var uncurryThis = __webpack_require__("5860");
var fails = __webpack_require__("fa22");
var classof = __webpack_require__("7d22");

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "0e7a":
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__("fd48")

function getColorAttrib (color, attrib) {
  var alpha = color.a / 255
  var str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  var str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  var path = ''
  var moveBy = 0
  var newRow = false
  var lineLength = 0

  for (var i = 0; i < data.length; i++) {
    var col = Math.floor(i % size)
    var row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  var opts = Utils.getOptions(options)
  var size = qrData.modules.size
  var data = qrData.modules.data
  var qrcodesize = size + opts.margin * 2

  var bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  var path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  var viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  var width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  var svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}


/***/ }),

/***/ "0ffc":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("1efa");
var FUNCTION_NAME_EXISTS = __webpack_require__("c0b1").EXISTS;
var uncurryThis = __webpack_require__("5860");
var defineProperty = __webpack_require__("9d17").f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /^\s*function ([^ (]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "11b1":
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__("5d60")

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  var i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  var remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData


/***/ }),

/***/ "160f":
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__("fd48")

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  var opts = options
  var canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  var size = Utils.getImageWidth(qrData.modules.size, opts)

  var ctx = canvasEl.getContext('2d')
  var image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  var opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  var canvasEl = exports.render(qrData, canvas, opts)

  var type = opts.type || 'image/png'
  var rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}


/***/ }),

/***/ "16ea":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("1efa");
var call = __webpack_require__("3b34");
var propertyIsEnumerableModule = __webpack_require__("e356");
var createPropertyDescriptor = __webpack_require__("5525");
var toIndexedObject = __webpack_require__("33fb");
var toPropertyKey = __webpack_require__("6f7a");
var hasOwn = __webpack_require__("8cfd");
var IE8_DOM_DEFINE = __webpack_require__("c708");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "17c4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1877":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var shared = __webpack_require__("808a");
var hasOwn = __webpack_require__("8cfd");
var uid = __webpack_require__("9eb7");
var NATIVE_SYMBOL = __webpack_require__("725c");
var USE_SYMBOL_AS_UID = __webpack_require__("07fd");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "1b98":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var userAgent = __webpack_require__("af16");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "1d18":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var isObject = __webpack_require__("7d3f");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "1dad":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1e6c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1efa":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fa22");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "1f41":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");
var requireObjectCoercible = __webpack_require__("41e6");
var toString = __webpack_require__("02f1");
var whitespaces = __webpack_require__("55c4");

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "1f86":
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__("e123")
var Mode = __webpack_require__("5d60")

function ByteData (data) {
  this.mode = Mode.BYTE
  this.data = BufferUtil.from(data)
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (var i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData


/***/ }),

/***/ "1fb5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("9363");
var redefine = __webpack_require__("d0ad");
var toString = __webpack_require__("5296");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "2458":
/***/ (function(module, exports) {

// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}


/***/ }),

/***/ "278c":
/***/ (function(module, exports) {

var numeric = '[0-9]+'
var alphanumeric = '[A-Z $%*+\\-./:]+'
var kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

var byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

var TEST_KANJI = new RegExp('^' + kanji + '$')
var TEST_NUMERIC = new RegExp('^' + numeric + '$')
var TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}


/***/ }),

/***/ "2ab7":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("b0ae");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ "2aff":
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__("e123")

var EXP_TABLE = BufferUtil.alloc(512)
var LOG_TABLE = BufferUtil.alloc(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  var x = 1
  for (var i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}


/***/ }),

/***/ "2fdd":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("1d18");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "30f4":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

var getSymbolSize = __webpack_require__("396b").getSymbolSize

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  var posCount = Math.floor(version / 7) + 2
  var size = getSymbolSize(version)
  var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  var positions = [size - 7] // Last coord is always (size - 7)

  for (var i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * var pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  var coords = []
  var pos = exports.getRowColCoords(version)
  var posLength = pos.length

  for (var i = 0; i < posLength; i++) {
    for (var j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) ||             // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}


/***/ }),

/***/ "3283":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var setGlobal = __webpack_require__("61ae");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "33fb":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("0c91");
var requireObjectCoercible = __webpack_require__("41e6");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "373b":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3808":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3958":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("f0e2");
var enumBugKeys = __webpack_require__("7a4f");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "396b":
/***/ (function(module, exports) {

var toSJISFunction
var CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  var digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}


/***/ }),

/***/ "3b34":
/***/ (function(module, exports) {

var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "3c2a":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "3c61":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "3f6b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var isCallable = __webpack_require__("3c61");
var inspectSource = __webpack_require__("fdd5");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "41e6":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "42d8":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ "4a41":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("3f6b");
var global = __webpack_require__("9c46");
var uncurryThis = __webpack_require__("5860");
var isObject = __webpack_require__("7d3f");
var createNonEnumerableProperty = __webpack_require__("9c72");
var hasOwn = __webpack_require__("8cfd");
var shared = __webpack_require__("3283");
var sharedKey = __webpack_require__("de90");
var hiddenKeys = __webpack_require__("b373");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "5157":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var isCallable = __webpack_require__("3c61");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "5296":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("9363");
var classof = __webpack_require__("7ec8");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "5525":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "55c4":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "5860":
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var callBind = bind && bind.bind(call);

module.exports = bind ? function (fn) {
  return fn && callBind(call, fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "5bd7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var call = __webpack_require__("3b34");
var isObject = __webpack_require__("7d3f");
var isSymbol = __webpack_require__("bb9a");
var getMethod = __webpack_require__("2ab7");
var ordinaryToPrimitive = __webpack_require__("0950");
var wellKnownSymbol = __webpack_require__("1877");

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "5d60":
/***/ (function(module, exports, __webpack_require__) {

var VersionCheck = __webpack_require__("7864")
var Regex = __webpack_require__("278c")

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  var lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),

/***/ "5e48":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "61ae":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "64af":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),

/***/ "6548":
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__("e123")
var GF = __webpack_require__("2aff")

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Buffer} p1 Polynomial
 * @param  {Buffer} p2 Polynomial
 * @return {Buffer}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  var coeff = BufferUtil.alloc(p1.length + p2.length - 1)

  for (var i = 0; i < p1.length; i++) {
    for (var j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Buffer} divident Polynomial
 * @param  {Buffer} divisor  Polynomial
 * @return {Buffer}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  var result = BufferUtil.from(divident)

  while ((result.length - divisor.length) >= 0) {
    var coeff = result[0]

    for (var i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    var offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Buffer}        Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  var poly = BufferUtil.from([1])
  for (var i = 0; i < degree; i++) {
    poly = exports.mul(poly, [1, GF.exp(i)])
  }

  return poly
}


/***/ }),

/***/ "6b0d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.default = (sfc, props) => {
    for (const [key, val] of props) {
        sfc[key] = val;
    }
    return sfc;
};


/***/ }),

/***/ "6bbd":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");
var aCallable = __webpack_require__("b0ae");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "6f7a":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("5bd7");
var isSymbol = __webpack_require__("bb9a");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "7079":
/***/ (function(module, exports) {

/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
var PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  var size = data.size
  var points = 0
  var sameCountCol = 0
  var sameCountRow = 0
  var lastCol = null
  var lastRow = null

  for (var row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (var col = 0; col < size; col++) {
      var module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  var size = data.size
  var points = 0

  for (var row = 0; row < size - 1; row++) {
    for (var col = 0; col < size - 1; col++) {
      var last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  var size = data.size
  var points = 0
  var bitsCol = 0
  var bitsRow = 0

  for (var row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (var col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  var darkCount = 0
  var modulesCount = data.data.length

  for (var i = 0; i < modulesCount; i++) darkCount += data.data[i]

  var k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  var size = data.size

  for (var col = 0; col < size; col++) {
    for (var row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  var numPatterns = Object.keys(exports.Patterns).length
  var bestPattern = 0
  var lowerPenalty = Infinity

  for (var p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    var penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}


/***/ }),

/***/ "725c":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("1b98");
var fails = __webpack_require__("fa22");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "74dd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_page_head_vue_vue_type_style_index_0_id_d087da92_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0077");
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_page_head_vue_vue_type_style_index_0_id_d087da92_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_page_head_vue_vue_type_style_index_0_id_d087da92_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7864":
/***/ (function(module, exports) {

/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}


/***/ }),

/***/ "7a4f":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7c3c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_gif_process_vue_vue_type_style_index_0_id_4435afae_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1e6c");
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_gif_process_vue_vue_type_style_index_0_id_4435afae_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_gif_process_vue_vue_type_style_index_0_id_4435afae_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7c50":
/***/ (function(module, exports) {

exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  var lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),

/***/ "7c99":
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__("396b")

var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
var G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  var data = ((errorCorrectionLevel.bit << 3) | mask)
  var d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}


/***/ }),

/***/ "7caf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("fa22");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "7d22":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "7d3f":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3c61");

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "7e9e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("1efa");
var global = __webpack_require__("9c46");
var uncurryThis = __webpack_require__("5860");
var isForced = __webpack_require__("f675");
var redefine = __webpack_require__("d0ad");
var hasOwn = __webpack_require__("8cfd");
var inheritIfRequired = __webpack_require__("e421");
var isPrototypeOf = __webpack_require__("fa7e");
var isSymbol = __webpack_require__("bb9a");
var toPrimitive = __webpack_require__("5bd7");
var fails = __webpack_require__("fa22");
var getOwnPropertyNames = __webpack_require__("3958").f;
var getOwnPropertyDescriptor = __webpack_require__("16ea").f;
var defineProperty = __webpack_require__("9d17").f;
var thisNumberValue = __webpack_require__("42d8");
var trim = __webpack_require__("1f41").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var arraySlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = arraySlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this;
    // check on 1..constructor(foo) case
    return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); })
      ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "7ebd":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("ceb0");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "7ec8":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var TO_STRING_TAG_SUPPORT = __webpack_require__("9363");
var isCallable = __webpack_require__("3c61");
var classofRaw = __webpack_require__("7d22");
var wellKnownSymbol = __webpack_require__("1877");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "8036":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var isObject = __webpack_require__("7d3f");

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ "808a":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("3c2a");
var store = __webpack_require__("3283");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.19.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "825b":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("64af");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "8390":
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__("e123")

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = BufferUtil.alloc(size * size)
  this.reservedBit = BufferUtil.alloc(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  var index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix


/***/ }),

/***/ "8502":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("5860");
var anObject = __webpack_require__("8036");
var aPossiblePrototype = __webpack_require__("ecfe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "87f3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("7d22");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "8863":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");
var fails = __webpack_require__("fa22");
var isCallable = __webpack_require__("3c61");
var classof = __webpack_require__("7ec8");
var getBuiltIn = __webpack_require__("5157");
var inspectSource = __webpack_require__("fdd5");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "892c":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("e0cf");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8cfd":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");
var toObject = __webpack_require__("f690");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "8ec5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANAAAAAmCAYAAAC1bxVwAAAKQklEQVR4Xu2d16sVsRbGc+y9945i7wV772JvD6KIL4L+QeKLIIiP9t67gti72Dsq9t69/BZkM2fuzE4yJ+679yWBje6ZZE2ysr6stb5k9in7+/fvX+W5IPLPnz/y4f/64/kxQVzQQKoGysrKlP5UqlRJ8eG771LmE0AA5vfv3zng+O5skBc0kFUDgAcQVa5cWf71VbwACA/z69cvAU8oQQPFrgFAVKVKFS8eqcIAAjSA5x9EgsU+D6F/JawBPBIgAkwVKRUCEMDhE0rQQKlqABDxyVoyAyiAJ6vKQ7ti00BFQJQJQAE8xWYCoT8V1UBWEDkDCKbtx48feftLnZcvX6rPnz9nGleNGjVUs2bNVNWqVTO1D42CBrJooFq1as4MnROAIAoATz7C4Pnz52rv3r3q9evXmYkFEry6deuqsWPHqs6dO2fRRWhTYA38iz2WrEPISmgxBkDkMhYnAJlCtzdv3qj169ernz9/Zh17uXbw9XPnzlUdOnTwIi8I8asB5vnt27fqw4cP6tu3b7kFM7pxro05/i89SbsX33i3rYdMopZ69eqp5s2bq0aNGjkP2DWUswYQg/j+/Xtqh0Dt1q1b1e3bt507na9B48aN1bJly7zKDMIqpgEW0ocPH6pnz57lIhLCdl3iAEr7bgJG9BRLUt040HQfuI49NmnSRPXr10+1bNnSacDVq1e39kLWADJ5Hzq/evVqWYl8lxUrVqjatWv7FhvkZdDAp0+f1NWrV9WXL1+kdfyoVtTQ0wCQVCfukWzBEw3XooDSx8gAUq9evdSAAQOsQeHihawBhPfJF1sCsFWrVnnfF0IRy5cvVw0aNMgw3aGJTw0AmgsXLpTLg9MAFPUGSR7IBXzRuvF2aQCKA7B79+5q6NChVuoAdHghm2IFIBvmLQDIRt2lWwcbOHfunDCr2jh1sh0HURw8aUafBL4s4V8+gEb7MmbMGNWpUyerSbBl5KwAZArf6FEAkNW8lGylx48fq7t375YL2wBQvnDMJvexrWMCIfdNwK1Zs6ZasGCB1faIbRhnBSCo62iSmGQFhQQQqyArRHSfCCaIa0wIitKFurB5nNmrU6dO7johqX7lwkUWdQllYHr0CoxsrvGcJFk81+cJ4EKjEJ2ePn06l9+meSDGDjOHPnQd5kKzsjoN4B57fdRDL9F8Sh/yRLfYXfScJXmw3kaJsn7I4hl88nlD5nv06NGqS5cuRhXquTRVtAKQKf8ptAe6d++eun79upoxY4aM786dO8L+jRw5Um3fvl3Nnz9fYlhAtXPnTqHCd+zYoUaNGiX0JhO3adMmhUsnKXaRhWyMCVD0799fnn/06FHJ0di7SpI1bdo00zwU9X10dPbs2VwfowCKeiA2v9u0aSN1ud6iRQvVunVrIR3IP44dOyYAqFWrlho2bJjobcSIEerixYuyb0iZMGGCOnPmjNTp2LGj1KG0bdtWtW/fXmSPHz9e7d69W2QBKtowzxpcaaEhcujP1KlTjXuUtnmQFYBsmLVCeiAUcfjwYTmtwB7Rtm3bBCSsRLdu3VIPHjxQEydOVFu2bFHDhw+XiXz37p3as2ePgItJAGAwM1lkAcCNGzfKxGFcly9fVjNnzswrq6gRYugcm+M3b940AgjDhfFC1y9evFBDhgxRp06dku0PDJd5QPcsdIAK0AAAwHXo0CFFog8Ibty4Ic8aNGiQ1Hn69KmAZt++fSKLOUfeiRMn1OTJkyU34+RLEnMXDeuQiUdctGiR1XRgT6ZSsgDCXeNFcPlMAArVZf/+/RIWwP8PHjw4dx3vAMBYXWbNmpULwbLIYmIPHjwoYSCyWDEp+WSZJqNY7z969Ejh9XVJ80BcJ/TBu7DIALpXr17lVnsWLBYudAdItBwAgYfR3lwbPbJYCJGFlwKUug0gxMC5xr2kXCx+DfnYy+LFi61eY/i/BhDKYHUjfIsrhE0+QrklS5aUo7/xpGvXrpXQrUePHuXs1VUWk7NhwwaRP2nSJCtZxQoQU78gEABQ3CCTWDjqdOvWTRYvogT9kiXXmzZtKiEbR73w3BoM5E7Tp09X58+f/6/n9O3bV7Vr106ijOhPBLRq1UrARSRAqB4nIxhTkkcib8ZebHJSbwAqthwI5eCyjx8/LnEy3oaJodDXzZs3i+dhZZozZ05OWbt27RIak70M8idNKmSRdenSJTGC9+/fCxj1caM0WSYjLeb7eBFCLhsPBLmCPgj78DbXrl2TZry4Rg5KFMD5RnIbbeB4rCdPnqiuXbtKnsR8cq9hw4Zq4MCBCgBjzACM63gR8hjmsWfPnpIPJe07JXkg+rdw4cLC5kDFxsIRJrHyoMT69evL6oSiSWCJk0k2mQySURRLLM5E4u6JpYmpuTd79mxheVxlEYIcOHBAKFF0Q66FLFa3NFnFDBBT31iUIE7iRhr3QDp80/tFhNaEzACQ8A1QAQY8FAUwsfAAFNpw9AbwHTlyRBY9PAx5zsePH9W4ceMExMggfEPO/fv3VZ8+fSQUB1xRr5PkgbR3pL0GV9rYvbJwmprMp+hCkgiEBii7d+/e0iU8ASDiO+AAWBQmnDyJxJbVKroHcPLkSVnVcP8usjAK2kIg0I4CaXHlyhXxaEmy5s2bJ88q1YKB4s05OBo1zPg+EHrGIxNCY6B4IPSFoXOmkUVLGy50MmEhlDIEgqarAQSARZccToZdpQ3JPzonr4JJ1ewc/YHlRDbgSgvdtLeD7IF8MhU8ps3rNFYkAnGs6YR1IQFkGny4718DAINFKA4gk8GmeYL4ddfv8ZwnKVyL50AQTVOmTLFSDuCx+b0EKwDRkXwnselRAJDVvJR0JQgbQidt7L5OIvgAoUkGRAVhdnQzPd9k2J7ItgIQDzLlQQFAJY0Nq84TEhNC6VApzWtwPcth0jRvFfUuaUCJXtfP1x4IbwJTSuhnU2zzH2RZA8gUxrEarVmzRjbRfBYYl5UrV8oRmVD+9xrAKMlxyPuiFLWNkUdDqnzgS6Kfk0K26LU0AJGTQhq4nOa3Dd+cAETlfHQ2AIKpgVr2WdidZo/AxJr4fGaQZdYAVDPUMwzb169fy4HJ1ZO4vIwX927xttghAOBtVOhy9pBschk9YtsjPLn6Lj/ta3qtgRVp3bp1wp74KJwtW7p0aUkzWD70UMwysAkWVk0yJS10ttfi44y3s1lEAQuMnetvG+hn277GkAlANDJR2oAISpejGnpDzNUAoHzZ8NRHP1zbh/pBA1k0YEtdR2Vb50C6EauA6Zd54vGo62D0r+q7tgv1gwayaiDLL/I450CuIMo6mNAuaKCQGsgKnswA0omcfoGpkIMNzwoa8KkBTTrYHC5Neq5zCBcVQjgHiExvq/occJAVNOBLA4AGxs7lhxTjz64QgLQwE7Hga8BBTtCALw1kIQy8e6DgjXxNZ5BTKA348DrRvnrxQHEgcaxHv/xUKMWE5wQNpGlA/3lHX3+VLg6gXf9K9eRI+m+m/qtnBLlBA2ka0H8TtSI5jkm7/wGtdnHrv/iAcgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "8f3d":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "90c3":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("33fb");
var toAbsoluteIndex = __webpack_require__("825b");
var lengthOfArrayLike = __webpack_require__("7ebd");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "9152":
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "9166":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_gzh_template_new_vue_vue_type_style_index_0_id_3695f397_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1dad");
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_gzh_template_new_vue_vue_type_style_index_0_id_3695f397_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_gzh_template_new_vue_vue_type_style_index_0_id_3695f397_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9363":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("1877");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "9928":
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__("5d60")
var Utils = __webpack_require__("396b")

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  var i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    var value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData


/***/ }),

/***/ "99c8":
/***/ (function(module, exports, __webpack_require__) {

var getSymbolSize = __webpack_require__("396b").getSymbolSize
var FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  var size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}


/***/ }),

/***/ "9a33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_text_process_vue_vue_type_style_index_0_id_83b76498_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a05f");
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_text_process_vue_vue_type_style_index_0_id_83b76498_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_text_process_vue_vue_type_style_index_0_id_83b76498_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9c46":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "9c72":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("1efa");
var definePropertyModule = __webpack_require__("9d17");
var createPropertyDescriptor = __webpack_require__("5525");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9d17":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var DESCRIPTORS = __webpack_require__("1efa");
var IE8_DOM_DEFINE = __webpack_require__("c708");
var anObject = __webpack_require__("8036");
var toPropertyKey = __webpack_require__("6f7a");

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9eb7":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "a05f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a16c":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "a612":
/***/ (function(module, exports, __webpack_require__) {

var ECLevel = __webpack_require__("7c50")

var EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

var EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}


/***/ }),

/***/ "a9c0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANAAAABSCAYAAAAl3FqnAAAW0UlEQVR4Xu3dBZBdxRIG4MHdE1yCu0PQJEUguAUneHBIcCfEcXeHQAia4BJcAgR3d4K7u736pmq2zrvcXfaRfXvv3jtTlcrm7JwzPX36n+456b9nnL/++uuv0AqtlYZphZnkIdqCBsYZZ5xWEXOc1gJQq8wmD5I10MoayABqZYXn4WpLAxlAtfU+82xaWQMZQK2s8DxcbWkgA6i23meeTStrIAOolRWeh6stDWQA1db7zLNpZQ1kALWywvNwtaWBDKDaep95Nq2sgQygVlZ4Hq62NJABVFvvM8+mlTWQAdTKCs/D1ZYG6hpAf/zxR5DkOv7448e3mv7t2rjjjhvGG2+8eP33338PkhP9Xl+/03777bf4s+sTTDBB7ONe1937559/xuta8XpxTH3c715/imMmUyu93lxZ3P/rr7/GZxpjwgkn/FeyFPXiWaXzTzLXFjSaN5uaAxCDTC84qaDcNb8bPXp0GDlyZOjbt2+855xzzgkzzjhjBMA333wTdtppp2h4/fv3DxtssEG49957w+KLLx7WWGON+Ps+ffqE/fbbL5xxxhmx74ILLhjeeOON+G/XjzvuuDBgwIAw3XTThfvuuy889NBDYZ111glXXHFFGDRoUATXpZdeGseedtppw+uvvx722muvKPbRRx8dOnXqFD799NPw+eefh1133TXK4r611lorPPzww2GBBRYIa6+9dvj222+jLPvss084++yzw3bbbRcWWWSR8Pbbb4dTTjklHHDAAeHYY48N/fr1C+3btw8PPvhguOeee0L37t3j+IMHD47guvzyyyPgZp555vDCCy+EfffdN8piHh07dozyTTPNNGHTTTcNP//8czj88MOjXPPPP3+j1va/vI/mmWx19aopAH333XfhzTffDLPOOmto165d1DTjeuutt8Jss80WDbnYeJbevXuH1VZbLcw+++zRUC6++OLoORghYL3yyivhkUceCSeddFIYM2ZM7H/++eeH8847Lz6vV69eEViunXvuufH3W265ZQSZa8YGph133DEcf/zxYd555w2HHHJIBBujPOyww8KQIUPCRBNNFHr27BmfB5zXXXddBAND3X777cOhhx4aAQGIp512Wnj//ffDHnvsEeVw/2STTRYBNGrUqHDmmWfGsf17o402iqA1r5deeimObRwAJYPx55xzztC5c+dw0EEHxX6eRd6dd945/PLLLxHwxvnqq6/ivca/9dZbw5dffhlB2VgzDzLTrQVC+/rrr8M777wT5phjjgjGtt5qBkA//fRTBM/3338fpp566rg6//jjj/HaDz/8EF9WuZXyww8/DLvvvnv0ArzFYostFt/p448/Ho1MAwwrt3bllVeG66+/Pkw88cTxOsPXeAZgm2uuucLAgQNjOGY192xy8BTbbLNN7MvweCx99t9//7DiiivG6y+//HIEinb66adH0GtPP/10fKYGVLykNmLEiHD11VdH78HAJ5lkknid3DwIwz3qqKPiOLzqnnvuGfVjwQCEZNDAog/vB0jaa6+9Fg488MB4nRfr0KFDvH7HHXdEcNLXBRdcEKaYYoqyGKDzpHu6m2eeeeLYFhS/m3766cPcc8/d1vETagJAjOPjjz+Ohsp7MGIvOF2z57DKJmMvvjX9eQ19hTCpj2dtscUWYb755oueKYWFVv7NNtsseqhddtklGpgmLGKAJ554YlhllVUahrjooouicQNeMkJjCn+effbZcM0118QVXwM4ILMAnHXWWQ37IV6ILO7nCZMsH330UQynevToEYGaZHn00UejdzrmmGNCt27dGmQZOnRoDC/NMxkv3fC0jz32WBg+fHgDIOiU57NQkD/tc3ihjTfeOD6XNytHXDMP+rSoaXSvpffhHu8o7Q/bMopqAkBWNgYvJLPaeTHlrpV7UTfffHPwR9wv7GOI2sknnxzDF3saxstgPH/vvfcOyy67bPRCgAVgwsQddtghbLXVVoGRAg2PZ7XVf/PNNw8PPPBADK3Idv/998fVe4klloie4eCDD45jXnjhhTHkEYp26dIlGioD542EQ8C74YYbxj2Q/ZA9ij0Z+XkaIZl7ySKMJItnCjXffffdGB4C21133RU9Gc9lXwas5kRnQjoGfskll0SPSL7lllsuzgHwjzjiiDDTTDPFUJGHWmaZZf6mVjIAD33xND68uOYdkTtda8vASbLXBIC8KMZutSx+xSq9VvrCGKRNMGOy6qd9D6Ox6WZENvE8i7DFXseHh1NPPbUBBK4DkhhfP6u1GN+qvttuu0XDsx8CEga+3nrrRQM/4YQT4j7Az0Ir91vRbep5HCEewH3xxRdxk++60C/texi+/RBw+aAABGQhm1DOvivte9zvPuBbd911G/Y99kdpP8Qj+dm+B0B8eDB/uk37Hh8R7IeMYz8l5DUG3RVbufdBpzwT2Uo/8rRlINUEgP7tC7jzzjsj4Lp27RofIaR69dVX4yq56KKLxi9ZKe63KovpGaE9CM8wbNiwGJ4888wz0cgYB9Ba9XkX+wigdK8vafYr9mEAYmOvGU/4JIyzZ0kruhXeXoHnsZ/jabS77747GjWQAiPPqTFse6Yky6STThoNNslif0YWxguI+i+00ELRM6y//vrxGQACjFNOOWV8Ls+jAat7PvvssxieppDs2muvjWPyXvXa6hpA9frS87xbTgMZQC2ny/ykOtRABlAdvvQ85ZbTQAZQy+kyP6kONZABVIcvPU+55TSQAdRyusxPqkMNZADV4UvPU245DWQAtZwu85PqUAMZQHX40vOUW04DVQWgdIJDa1XWbzk15ifVqwYqDiAJijgiUkWkwUi2nGqqqWICZGKK1uvLyfOufg1UFECycyUlSpHXEiWaJ5IbJlerFkhX1W8GWcJ/q4GKAUhCJdKavxsL2VyXlFnKJP23k833ZQ20tAYqAiAeRuaz7N5/2u8guK2wwgp/C+eQs1AAcFrwWPzRUqY0qoJnyypOGchS6oWFACl0xEYlCwq4vp988kn8N++HaSmbWRa1vvponksm1Imm+hjTOPo2JR/qgIxwIWxz5BPiknFs55DGbWmDqrfnVQRAQjdp88XGINF+AYPRpsZ4UQu88GJ76qmnwhNPPNFQawBLVG0APBgkuOeeey7ewyjXXHPNyKnB/VE4RAEO1GSGCzRoC2oVYHvi52CP4u+gAiy11FKxAAfmJ5D5HbIaKoMaAshz+qAZkEGfq666KtKmy8mHBIdoZwFpSj5UC8+yyAhl0SCwXRH0UKzNodhn4YUXLjsH8vHiuEybbLJJnDMqAzJcLfFyKgXcigDIyo+zn16gFZUx+XjggwKjLjZeJXFziteRufBZGD+WJu+AeIbPg5zG2zA6hojzs+SSS8b6AozdNWDDrUF9Zljbbrtt9DS33XZb5MbwMACFccpoNYU68GUU1QBUP6M+pz6ey8hdJx/vg6ymJkI5+YBWw7MBRHwejFFNvQTyqXHA82y99dYNnB99ys0BJRxHp9wcsGzdk+ZQKaOrpXErAiD0YmSzYvgGRAhlqb5BUcnCFcZf2hgw5iTPgxXJW1lZEcF4A02tAsU/UKiFU770KaKBur3SSivFPohu6giomgPUQIx8xrgZP9mKACJ3c/og4AEpZmeSj9dCQMNU1ZDVMGJ5O/IJG8nHW6688spl5WtOnySfBYRnT3PwNy/4T6FzLRn5/3MuFQGQYhjPP//830IIK2c5APFOQpRiAwR1ANQhUJ8AkHgFnuTFF1+MIRePxvDRmK3sDDMxNG+55ZboKXgOAOLhrPY8Bbq1OnBCHVVyeMskr3CKp9AHO1WBjnJ9VPc58sgjo3xKVAE2r8Bw1RpQ78AXRl4Bs5RnJJ+Qy73mgiLOwwoJhbF0Yy7/1AfbtXQOdCKspR/U8nK1DP6fhlarz64IgMrtgSi4HICsmIwnlXJKL4JRWVmXXnrpWFSDcVnxhT2MzqruYwC6Ms/G6GaYYYa4x2Ko7733XgQe2jRvJOTicVSLEfoxavssRvfBBx80lHhS/4Dx8QKpD3AJz1IZKH2EgkCvL7DqX5RPDYPJJ588PkNtBOGeYhsWF/UQPA/w6EpthSSfDyo+/euT5lDsA5Ao14Bi7oBpv1Wcg3oPPCPad25jp4GKAIjIjI4xF0MJIYwwDBhSU2dg+eWXbygWkq7zQMUyVYzIv1NREQbrWT5OaH5WKaZY1MIndCFbKnlr7+S5RcNyD0ClEkxk46lSDTbPbk6flpTPnNL+sbE5kC/ptpx8xdLFY2dC9X13xQDEwH2l4gEai8eBwd6ntOpLfb+yPPtq0kDFAEQJVnv7AaWbUh5cUo7wRqxuH5Nb1kC1aqCiAKIUwLFnkc4DUMIloLHBzv9PUa1mk+VKGqg4gPKryBpoyxrIAGrLby/LXnENZABV/BVkAdqyBjKA2vLby7JXXAMZQBV/BVmAtqyBqgGQr3HpU3b++taWTaq+ZK84gPzPvpR9FIYipVv+m8yCnPRYXwbZ1mZbUQA5ukOipmyEotdJp1jjwABSBlFbM6v6kbdiAMKTQemWf9ZYAyRZ0qVkuvp5PXmm1a6BigAIMOTB8UDFJklSoqawLnkdmQkO4U0Jn6m/g6nQtZHeJKXKZnAfuoHEURnI7uXF3OvoxHTkumxlfaURuYY+wAP6t3s8U/a3Z8qKFlqmA648V5aE8LKpPn4/yyyzxCxqBEG0Cfl/MrSTfHL9HJ5FPgdmWUzI0ZR8sjTI01Qfia9SoRqTT4a5MZuSD/1DHmL2/k1DuCIAYpiOjk8vB6CcNcqggAhRLtU48DtGlk6sTtPRBx0BZwYvyDGJjlfEIMV9YbAAhrjnKEMUA1QHPBmkNvcmCjlj4+lQHlAHHJvoEGB/owRgfyLfMW7nmzoz1VHvqQ/uEHp16uM8VMc6oiPgHOEFJfmwVwEV4Q3lwclxuEEoBjhNSb4bbrghUiscMSk7HMhxmZDhMFTNQR+EPwAt9inOwaHCKBNYuBaiNAc0dyfMYaeWk09qFU5VblUIINwUnJYEIH9LHLUfsiryArguqeHx4ASVNiAQBjJyLFQvnQFapRkjY0lnljr706rNE7nGOF3jDTBRgRrAeBfsVMbZsWPHSJqz4jNacqKK8y4WgBtvvLHJPp7hWeRDySgnn/NGyYTfQ6YkH1mdAk4+c7Ig4PAopNKcPk3NQb0HCxX5zQPA8IyAmi6K+ssAqkIANUbp5gl4Ih5EuJNaY5RuoYh6BgyMtxGWYYcCm/oGDP7222+PR8kjmgnNAMWqi/LNS/BwKNfG5MmEP2o2ACCwWPkZMWq0vgmYjfUhMyACL86TZ5LPwkA+p2AL49LZqYqbIAdizib5eBkFQHgJY6rzYHFJ8pWbQ2mf5syhnHy8qjA4yZcBVIUAsmdh/MWiItiYPI2Qy4pfjL2FOsK4YmNEVsvevXvHE6oZJgq2fuJ3KyrgAYeQK4VTTrHmVdC4gQyVQoUg8b5wSsUdhupUa+EPwFjNhZTktXIrAJLCnmKfxG1KJMCifIANKBYI+ygeqX379pGJaswUTgkNeSygVyCE11LXAfOW13YN2NIcSvsID0vnANA8NS/Gu/OgwjlhrRDYaeDkoxNhLWDx6BaP3KoQQACimIaVXQMW+wfG7Jr/F/JzqlTKuNu1a/dfM1FeSnEOewAAEPIxcnRtLE3lq2yUFe8AJOFe2qR379491mHzDJ7OngEw7IHQwAGWPMpPOUrec3v16hXHBxihllBPHzRtex6ATn0YJG/aqVOnaJCjR48OvC6Akc/8Uc6L8gn3fEAxZ3s2wLEglMrXoUOHGGo11eef5pDkU7RERSNhnI8Y5imUJJ8+wJXLK1chgIjkK9qYMWMaPE2iXvsdQ/JH8xVLXYFKZScIoUq/RJVea06fSq7k/1a+cvdVch7VOHZFvsIlkAi1rLSNfSoVaghdcvGLajSdLFOMnv4q5VK3ol54GWGSDW/yOIZPZXH9H07RM7WiaHmorIFmaaCiAEoSirltcBOl29cocXxuWQPVroGqAFC1KynLlzXQmAYygLJtZA2MhQYygMZCefnWrIEMoGwDWQNjoYEMoLFQXr41a6AqAJTo3EVKd06jz8bZFjRQcQApfC47W+qOZEuUBtnAiauSgdQWzKh+ZawYgHgbXBfJj0UCnVeRUkik9Ms7yyCqXwOt9plXDEBSeJ588skm9QNIkh0lUOaWNVCNGqgIgGRcowjITk5N+o7EUd6o9LrU+9KUHodfCfNQILBThYKylGUYy7qWIS3bWSa3rAYHTcmtk6nthDljuCbbuXPnzjF0RBtwlIqxABfTU8KrLAkUBp7QgcOytclbro/5ONBXGKofWnWSz6IhQ5t8mK3kcQCwzG15geRN8jlPyByL8slgx8wV7jY2B32MnebAy8sEL51DUT4Z5fSBYk9/3g/5yFOUj27o43+ZA+o+/dZqqwiAGDp+SpHSreaA62gCqAnoBimcw6FxiluxMQyUBSxNdGjkN5Tn1VdfPXKN8IsUI0GoQ2lwTqo+CHjOH8V96datWwSJU+EAbeTIkZGlin2KtYmEpy/QpGPhyYbCXa4PUp85qaPglG7yIceVkw8XSH9j4u/oSz59yTB8+PCw6qqrRmqHPaKkWkdEoobjK5ELZyj1kU9YOge0b/wnz0PLAGYLBRCYO0pFUX/oHORG3kMBSQcuk09fZDvcK/fqg2LS1BxGjBgRFx4EvVptFQEQA7P3Ke5trG5WSccx8ibFk7qBoRy5yyrpjFKEMSCzavfr1y+GfAxNQ2IbNWpUvM5oGWT//v1Dly5dGg4ixvFhVK7L/EbqwyJ1vql+PAaj1RD3GGHq4+RsK2zqY07IafrwgpdddlmUT2KseZHDYpDkA2T9+vbtG0FPvgEDBsRVPh1EjJuDr+M6+dIcjFvsw9MU54BF26NHj0bnkOQDIkTEJJ93kLhNQAp85CafPmQ1h9THHLyL1EeNP3LwZsiMtdwqAqDGKN1WSGEZrlAxjGuM0s0AkM5QtBmoewYOHBgBhCSnWckBqE+fPtEAeK5BgwZFo0eb1qyuAMQwGKjxeR8ASuEKz6BZ1ZHMSvvIJtcHgFIf4w4bNix6IfIBOPkYKPn0TfJZ3YWj5Bs8eHA0vlTUg3cCIPIJR8vNobRPkg+AEsBL5yBkJZ/CJwBUTj5eBDjoj3yNzcG7SH0AnI7THGr5I1BFAMQAxPyJJGe1ZlRicWEBwFjhEyPVasfDlAvhUK6FZYwWPVqdA3sbIZcXLoRjREAiLGNEjBcbVbhHFiGSPYW+PXv2jM/jRRw6LPxhQJ5FTt5TEY7Uxyqv+Ic+FgAyC6eELoy6KN+QIUNi+IPSra8/wjJALSefvlZzYSNSob4ORDZ2moM+KcwzByEh1ms5+Ypz6Nq1a1n5hHAo3SkENiYvK3QTYgqF0xw8j55L54AqTic8kxBTwZhabRUBkA8FNrtFDpAVEKBsrIEneSBf4lC3S89JVePAxwUvUS0DL92m1/5EODV06NBozLyMVZs3YGjCOF7FSio88Xx1BYDjpptuipt4RT/E7cClXJXGyDUho30aL8cwGuvjuYwHSJojH28gbCUfj1GUjwHzeqrooHqQtbE+jc2BPJ6T5uBvICIfb5VqxTWmP+8L3QR1PfURnmpJx/qYgwVQ6GsOPCz91qoXqgiAKF1pJl+nih8SVMRh/L4CJe/DoHxgqNUXUKsrc73Mq2IAAhJVZlToKdesmD5r+7JUWpW0Xl5Onmf1a6BiAKIaILL/sIEXOqVcOJ5IbC0Twc+5ZQ1UqwYAaJVKC2cvZLPsP/L8p6IYOtdCqPRbyeM3RwP/AdxyakzpEZPnAAAAAElFTkSuQmCC"

/***/ }),

/***/ "ae45":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.8
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ clipboard; }
});

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(279);
var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
// EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
var listen = __webpack_require__(370);
var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
// EXTERNAL MODULE: ./node_modules/select/src/select.js
var src_select = __webpack_require__(817);
var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
;// CONCATENATED MODULE: ./src/clipboard-action.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */

var ClipboardAction = /*#__PURE__*/function () {
  /**
   * @param {Object} options
   */
  function ClipboardAction(options) {
    _classCallCheck(this, ClipboardAction);

    this.resolveOptions(options);
    this.initSelection();
  }
  /**
   * Defines base properties passed from constructor.
   * @param {Object} options
   */


  _createClass(ClipboardAction, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = options.action;
      this.container = options.container;
      this.emitter = options.emitter;
      this.target = options.target;
      this.text = options.text;
      this.trigger = options.trigger;
      this.selectedText = '';
    }
    /**
     * Decides which selection strategy is going to be applied based
     * on the existence of `text` and `target` properties.
     */

  }, {
    key: "initSelection",
    value: function initSelection() {
      if (this.text) {
        this.selectFake();
      } else if (this.target) {
        this.selectTarget();
      }
    }
    /**
     * Creates a fake textarea element, sets its value from `text` property,
     */

  }, {
    key: "createFakeElement",
    value: function createFakeElement() {
      var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
      this.fakeElem = document.createElement('textarea'); // Prevent zooming on iOS

      this.fakeElem.style.fontSize = '12pt'; // Reset box model

      this.fakeElem.style.border = '0';
      this.fakeElem.style.padding = '0';
      this.fakeElem.style.margin = '0'; // Move element out of screen horizontally

      this.fakeElem.style.position = 'absolute';
      this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

      var yPosition = window.pageYOffset || document.documentElement.scrollTop;
      this.fakeElem.style.top = "".concat(yPosition, "px");
      this.fakeElem.setAttribute('readonly', '');
      this.fakeElem.value = this.text;
      return this.fakeElem;
    }
    /**
     * Get's the value of fakeElem,
     * and makes a selection on it.
     */

  }, {
    key: "selectFake",
    value: function selectFake() {
      var _this = this;

      var fakeElem = this.createFakeElement();

      this.fakeHandlerCallback = function () {
        return _this.removeFake();
      };

      this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
      this.container.appendChild(fakeElem);
      this.selectedText = select_default()(fakeElem);
      this.copyText();
      this.removeFake();
    }
    /**
     * Only removes the fake element after another click event, that way
     * a user can hit `Ctrl+C` to copy because selection still exists.
     */

  }, {
    key: "removeFake",
    value: function removeFake() {
      if (this.fakeHandler) {
        this.container.removeEventListener('click', this.fakeHandlerCallback);
        this.fakeHandler = null;
        this.fakeHandlerCallback = null;
      }

      if (this.fakeElem) {
        this.container.removeChild(this.fakeElem);
        this.fakeElem = null;
      }
    }
    /**
     * Selects the content from element passed on `target` property.
     */

  }, {
    key: "selectTarget",
    value: function selectTarget() {
      this.selectedText = select_default()(this.target);
      this.copyText();
    }
    /**
     * Executes the copy operation based on the current selection.
     */

  }, {
    key: "copyText",
    value: function copyText() {
      var succeeded;

      try {
        succeeded = document.execCommand(this.action);
      } catch (err) {
        succeeded = false;
      }

      this.handleResult(succeeded);
    }
    /**
     * Fires an event based on the copy operation result.
     * @param {Boolean} succeeded
     */

  }, {
    key: "handleResult",
    value: function handleResult(succeeded) {
      this.emitter.emit(succeeded ? 'success' : 'error', {
        action: this.action,
        text: this.selectedText,
        trigger: this.trigger,
        clearSelection: this.clearSelection.bind(this)
      });
    }
    /**
     * Moves focus away from `target` and back to the trigger, removes current selection.
     */

  }, {
    key: "clearSelection",
    value: function clearSelection() {
      if (this.trigger) {
        this.trigger.focus();
      }

      document.activeElement.blur();
      window.getSelection().removeAllRanges();
    }
    /**
     * Sets the `action` to be performed which can be either 'copy' or 'cut'.
     * @param {String} action
     */

  }, {
    key: "destroy",

    /**
     * Destroy lifecycle.
     */
    value: function destroy() {
      this.removeFake();
    }
  }, {
    key: "action",
    set: function set() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
      this._action = action;

      if (this._action !== 'copy' && this._action !== 'cut') {
        throw new Error('Invalid "action" value, use either "copy" or "cut"');
      }
    }
    /**
     * Gets the `action` property.
     * @return {String}
     */
    ,
    get: function get() {
      return this._action;
    }
    /**
     * Sets the `target` property using an element
     * that will be have its content copied.
     * @param {Element} target
     */

  }, {
    key: "target",
    set: function set(target) {
      if (target !== undefined) {
        if (target && _typeof(target) === 'object' && target.nodeType === 1) {
          if (this.action === 'copy' && target.hasAttribute('disabled')) {
            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
          }

          if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
          }

          this._target = target;
        } else {
          throw new Error('Invalid "target" value, use a valid Element');
        }
      }
    }
    /**
     * Gets the `target` property.
     * @return {String|HTMLElement}
     */
    ,
    get: function get() {
      return this._target;
    }
  }]);

  return ClipboardAction;
}();

/* harmony default export */ var clipboard_action = (ClipboardAction);
;// CONCATENATED MODULE: ./src/clipboard.js
function clipboard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboard_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboard_typeof(obj); }

function clipboard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function clipboard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function clipboard_createClass(Constructor, protoProps, staticProps) { if (protoProps) clipboard_defineProperties(Constructor.prototype, protoProps); if (staticProps) clipboard_defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }




/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */

function getAttributeValue(suffix, element) {
  var attribute = "data-clipboard-".concat(suffix);

  if (!element.hasAttribute(attribute)) {
    return;
  }

  return element.getAttribute(attribute);
}
/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */


var Clipboard = /*#__PURE__*/function (_Emitter) {
  _inherits(Clipboard, _Emitter);

  var _super = _createSuper(Clipboard);

  /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */
  function Clipboard(trigger, options) {
    var _this;

    clipboard_classCallCheck(this, Clipboard);

    _this = _super.call(this);

    _this.resolveOptions(options);

    _this.listenClick(trigger);

    return _this;
  }
  /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */


  clipboard_createClass(Clipboard, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
      this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
      this.text = typeof options.text === 'function' ? options.text : this.defaultText;
      this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
    }
    /**
     * Adds a click event listener to the passed trigger.
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     */

  }, {
    key: "listenClick",
    value: function listenClick(trigger) {
      var _this2 = this;

      this.listener = listen_default()(trigger, 'click', function (e) {
        return _this2.onClick(e);
      });
    }
    /**
     * Defines a new `ClipboardAction` on each click event.
     * @param {Event} e
     */

  }, {
    key: "onClick",
    value: function onClick(e) {
      var trigger = e.delegateTarget || e.currentTarget;

      if (this.clipboardAction) {
        this.clipboardAction = null;
      }

      this.clipboardAction = new clipboard_action({
        action: this.action(trigger),
        target: this.target(trigger),
        text: this.text(trigger),
        container: this.container,
        trigger: trigger,
        emitter: this
      });
    }
    /**
     * Default `action` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultAction",
    value: function defaultAction(trigger) {
      return getAttributeValue('action', trigger);
    }
    /**
     * Default `target` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultTarget",
    value: function defaultTarget(trigger) {
      var selector = getAttributeValue('target', trigger);

      if (selector) {
        return document.querySelector(selector);
      }
    }
    /**
     * Returns the support of the given action, or all actions if no action is
     * given.
     * @param {String} [action]
     */

  }, {
    key: "defaultText",

    /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */
    value: function defaultText(trigger) {
      return getAttributeValue('text', trigger);
    }
    /**
     * Destroy lifecycle.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.listener.destroy();

      if (this.clipboardAction) {
        this.clipboardAction.destroy();
        this.clipboardAction = null;
      }
    }
  }], [{
    key: "isSupported",
    value: function isSupported() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
      var actions = typeof action === 'string' ? [action] : action;
      var support = !!document.queryCommandSupported;
      actions.forEach(function (action) {
        support = support && !!document.queryCommandSupported(action);
      });
      return support;
    }
  }]);

  return Clipboard;
}((tiny_emitter_default()));

/* harmony default export */ var clipboard = (Clipboard);

/***/ }),

/***/ 828:
/***/ (function(module) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ 438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var closest = __webpack_require__(828);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ 879:
/***/ (function(__unused_webpack_module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ 370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var is = __webpack_require__(879);
var delegate = __webpack_require__(438);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ 817:
/***/ (function(module) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ 279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(134);
/******/ })()
.default;
});

/***/ }),

/***/ "af16":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5157");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "b0ae":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var isCallable = __webpack_require__("3c61");
var tryToString = __webpack_require__("5e48");

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "b373":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "b4fa":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "b639":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("1fb5")
var ieee754 = __webpack_require__("9152")
var isArray = __webpack_require__("e3db")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "b923":
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__("5d60")

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
var ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  var i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    var value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData


/***/ }),

/***/ "bb9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var getBuiltIn = __webpack_require__("5157");
var isCallable = __webpack_require__("3c61");
var isPrototypeOf = __webpack_require__("fa7e");
var USE_SYMBOL_AS_UID = __webpack_require__("07fd");

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),

/***/ "bd2d":
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__("396b")
var ECCode = __webpack_require__("a612")
var ECLevel = __webpack_require__("7c50")
var Mode = __webpack_require__("5d60")
var VersionCheck = __webpack_require__("7864")
var isArray = __webpack_require__("8f3d")

// Generator polynomial used to encode version information
var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
var G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  var totalBits = 0

  segments.forEach(function (data) {
    var reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
    var length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  var totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  var usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  var seg

  var ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  var d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}


/***/ }),

/***/ "bd3c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_course_qrcode_vue_vue_type_style_index_0_id_24de772d_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c597");
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_course_qrcode_vue_vue_type_style_index_0_id_24de772d_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_course_qrcode_vue_vue_type_style_index_0_id_24de772d_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c0b1":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("1efa");
var hasOwn = __webpack_require__("8cfd");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "c1c3":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "c48e":
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__("e123")
var Polynomial = __webpack_require__("6548")
var Buffer = __webpack_require__("b639").Buffer

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Buffer} data Buffer containing input data
 * @return {Buffer}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  var pad = BufferUtil.alloc(this.degree)
  var paddedData = Buffer.concat([data, pad], data.length + this.degree)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  var remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  var start = this.degree - remainder.length
  if (start > 0) {
    var buff = BufferUtil.alloc(this.degree)
    remainder.copy(buff, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder


/***/ }),

/***/ "c597":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c708":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("1efa");
var fails = __webpack_require__("fa22");
var createElement = __webpack_require__("1d18");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ceb0":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("64af");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "d0ad":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var isCallable = __webpack_require__("3c61");
var hasOwn = __webpack_require__("8cfd");
var createNonEnumerableProperty = __webpack_require__("9c72");
var setGlobal = __webpack_require__("61ae");
var inspectSource = __webpack_require__("fdd5");
var InternalStateModule = __webpack_require__("4a41");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("c0b1").CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "d0b4":
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__("5d60")
var NumericData = __webpack_require__("11b1")
var AlphanumericData = __webpack_require__("b923")
var ByteData = __webpack_require__("1f86")
var KanjiData = __webpack_require__("9928")
var Regex = __webpack_require__("278c")
var Utils = __webpack_require__("396b")
var dijkstra = __webpack_require__("fb15")

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  var segments = []
  var result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  var numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  var alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  var byteSegs
  var kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  var nodes = []
  for (var i = 0; i < segs.length; i++) {
    var seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  var table = {}
  var graph = {'start': {}}
  var prevNodeIds = ['start']

  for (var i = 0; i < nodes.length; i++) {
    var nodeGroup = nodes[i]
    var currentNodeIds = []

    for (var j = 0; j < nodeGroup.length; j++) {
      var node = nodeGroup[j]
      var key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (var n = 0; n < prevNodeIds.length; n++) {
        var prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]]['end'] = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  var mode
  var bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  var segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  var nodes = buildNodes(segs)
  var graph = buildGraph(nodes, version)
  var path = dijkstra.find_path(graph.map, 'start', 'end')

  var optimizedSegs = []
  for (var i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}


/***/ }),

/***/ "daa7":
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__("e123")
var Utils = __webpack_require__("396b")
var ECLevel = __webpack_require__("7c50")
var BitBuffer = __webpack_require__("e50d")
var BitMatrix = __webpack_require__("8390")
var AlignmentPattern = __webpack_require__("30f4")
var FinderPattern = __webpack_require__("99c8")
var MaskPattern = __webpack_require__("7079")
var ECCode = __webpack_require__("a612")
var ReedSolomonEncoder = __webpack_require__("c48e")
var Version = __webpack_require__("bd2d")
var FormatInfo = __webpack_require__("7c99")
var Mode = __webpack_require__("5d60")
var Segments = __webpack_require__("d0b4")
var isArray = __webpack_require__("8f3d")

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  var size = matrix.size
  var pos = FinderPattern.getPositions(version)

  for (var i = 0; i < pos.length; i++) {
    var row = pos[i][0]
    var col = pos[i][1]

    for (var r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (var c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  var size = matrix.size

  for (var r = 8; r < size - 8; r++) {
    var value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  var pos = AlignmentPattern.getPositions(version)

  for (var i = 0; i < pos.length; i++) {
    var row = pos[i][0]
    var col = pos[i][1]

    for (var r = -2; r <= 2; r++) {
      for (var c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  var size = matrix.size
  var bits = Version.getEncodedBits(version)
  var row, col, mod

  for (var i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  var size = matrix.size
  var bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  var i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix} matrix Modules matrix
 * @param  {Buffer}    data   Data codewords
 */
function setupData (matrix, data) {
  var size = matrix.size
  var inc = -1
  var row = size - 1
  var bitIndex = 7
  var byteIndex = 0

  for (var col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (var c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          var dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Buffer}                        Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  var buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  var totalCodewords = Utils.getSymbolTotalCodewords(version)
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  var remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (var i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Buffer}                         Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  var totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  var dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  var ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  var blocksInGroup2 = totalCodewords % ecTotalBlocks
  var blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  var rs = new ReedSolomonEncoder(ecCount)

  var offset = 0
  var dcData = new Array(ecTotalBlocks)
  var ecData = new Array(ecTotalBlocks)
  var maxDataSize = 0
  var buffer = BufferUtil.from(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (var b = 0; b < ecTotalBlocks; b++) {
    var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  var data = BufferUtil.alloc(totalCodewords)
  var index = 0
  var i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  var segments

  if (isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    var estimatedVersion = version

    if (!estimatedVersion) {
      var rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments,
        errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  var bestVersion = Version.getBestVersionForData(segments,
      errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  var dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  var moduleCount = Utils.getSymbolSize(version)
  var modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  var errorCorrectionLevel = ECLevel.M
  var version
  var mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}


/***/ }),

/***/ "dcf6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("e6ae").forEach;
var arrayMethodIsStrict = __webpack_require__("7caf");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "dd38":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dddc":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var DOMIterables = __webpack_require__("b4fa");
var DOMTokenListPrototype = __webpack_require__("2fdd");
var forEach = __webpack_require__("dcf6");
var createNonEnumerableProperty = __webpack_require__("9c72");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "de90":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("808a");
var uid = __webpack_require__("9eb7");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "e0cf":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var isArray = __webpack_require__("87f3");
var isConstructor = __webpack_require__("8863");
var isObject = __webpack_require__("7d3f");
var wellKnownSymbol = __webpack_require__("1877");

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "e123":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Implementation of a subset of node.js Buffer methods for the browser.
 * Based on https://github.com/feross/buffer
 */

/* eslint-disable no-proto */



var isArray = __webpack_require__("8f3d")

function typedArraySupport () {
  // Can typed array instances be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

var K_MAX_LENGTH = Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff

function Buffer (arg, offset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, offset, length)
  }

  if (typeof arg === 'number') {
    return allocUnsafe(this, arg)
  }

  return from(this, arg, offset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array

  // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true,
      enumerable: false,
      writable: false
    })
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

function createBuffer (that, length) {
  var buf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    buf = new Uint8Array(length)
    buf.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    buf = that
    if (buf === null) {
      buf = new Buffer(length)
    }
    buf.length = length
  }

  return buf
}

function allocUnsafe (that, size) {
  var buf = createBuffer(that, size < 0 ? 0 : checked(size) | 0)

  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      buf[i] = 0
    }
  }

  return buf
}

function fromString (that, string) {
  var length = byteLength(string) | 0
  var buf = createBuffer(that, length)

  var actual = buf.write(string)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (that, array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    buf.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    buf = fromArrayLike(that, buf)
  }

  return buf
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(that, len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function byteLength (string) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  return utf8ToBytes(string).length
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function from (that, value, offset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, offset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, offset)
  }

  return fromObject(that, value)
}

Buffer.prototype.write = function write (string, offset, length) {
  // Buffer#write(string)
  if (offset === undefined) {
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
    } else {
      length = undefined
    }
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  return utf8Write(this, string, offset, length)
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    // Return an augmented `Uint8Array` instance
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

Buffer.prototype.fill = function fill (val, start, end) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : new Buffer(val)
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return createBuffer(null, 0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = allocUnsafe(null, length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

Buffer.byteLength = byteLength

Buffer.prototype._isBuffer = true
Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

module.exports.alloc = function (size) {
  var buffer = new Buffer(size)
  buffer.fill(0)
  return buffer
}

module.exports.from = function (data) {
  return new Buffer(data)
}


/***/ }),

/***/ "e356":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "e3db":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "e421":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3c61");
var isObject = __webpack_require__("7d3f");
var setPrototypeOf = __webpack_require__("8502");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "e50d":
/***/ (function(module, exports) {

function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    var bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (var i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    var bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer


/***/ }),

/***/ "e6ae":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("6bbd");
var uncurryThis = __webpack_require__("5860");
var IndexedObject = __webpack_require__("0c91");
var toObject = __webpack_require__("f690");
var lengthOfArrayLike = __webpack_require__("7ebd");
var arraySpeciesCreate = __webpack_require__("892c");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "ecfe":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var isCallable = __webpack_require__("3c61");

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ "f0e2":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");
var hasOwn = __webpack_require__("8cfd");
var toIndexedObject = __webpack_require__("33fb");
var indexOf = __webpack_require__("90c3").indexOf;
var hiddenKeys = __webpack_require__("b373");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "f675":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fa22");
var isCallable = __webpack_require__("3c61");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "f690":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9c46");
var requireObjectCoercible = __webpack_require__("41e6");

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "f9af":
/***/ (function(module, exports, __webpack_require__) {


var canPromise = __webpack_require__("2458")

var QRCode = __webpack_require__("daa7")
var CanvasRenderer = __webpack_require__("160f")
var SvgRenderer = __webpack_require__("0e7a")

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  var args = [].slice.call(arguments, 1)
  var argsNum = args.length
  var isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        var data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    var data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})


/***/ }),

/***/ "fa22":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "fa7e":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "fad5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_gzh_template_old_vue_vue_type_style_index_0_id_51150de6_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dd38");
/* harmony import */ var _vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_gzh_template_old_vue_vue_type_style_index_0_id_51150de6_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vue3_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_vue3_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_vue3_node_modules_vue_loader_v16_dist_stylePostLoader_js_vue3_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_vue3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_vue3_node_modules_cache_loader_dist_cjs_js_ref_1_0_vue3_node_modules_vue_loader_v16_dist_index_js_ref_1_1_gzh_template_old_vue_vue_type_style_index_0_id_51150de6_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "fb15":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (true) {
  module.exports = dijkstra;
}


/***/ }),

/***/ "fb152":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("241c");

// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("dddc");

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("0ffc");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");

// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/page-head/page-head.vue?vue&type=template&id=d087da92&scoped=true


const _withScopeId = n => (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["pushScopeId"])("data-v-d087da92"),n=n(),Object(external_commonjs_vue_commonjs2_vue_root_Vue_["popScopeId"])(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("i", { class: "check-title" }, null, -1))
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "bottom" }

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", {
    class: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeClass"])(['page-head', $props.theme])
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", _hoisted_1, [
      _hoisted_2,
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", _hoisted_3, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.pageTitle), 1)
    ]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", _hoisted_4, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.pageSubTitle), 1)
  ], 2))
}
// CONCATENATED MODULE: ../packages/components/page-head/page-head.vue?vue&type=template&id=d087da92&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/page-head/page-head.vue?vue&type=script&lang=js
/* harmony default export */ var page_headvue_type_script_lang_js = ({
  name: 'PageHead',
  props: {
    theme: {
      type: String,
      default: 'bt-blue'
    },
    pageTitle: {
      type: String,
      default: '恭喜购课成功'
    },
    pageSubTitle: {
      type: String,
      default: '请关注公众号获取上课方式'
    }
  }
});
// CONCATENATED MODULE: ../packages/components/page-head/page-head.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ../packages/components/page-head/page-head.vue?vue&type=style&index=0&id=d087da92&lang=scss&scoped=true
var page_headvue_type_style_index_0_id_d087da92_lang_scss_scoped_true = __webpack_require__("74dd");

// EXTERNAL MODULE: ./node_modules/vue-loader-v16/dist/exportHelper.js
var exportHelper = __webpack_require__("6b0d");
var exportHelper_default = /*#__PURE__*/__webpack_require__.n(exportHelper);

// CONCATENATED MODULE: ../packages/components/page-head/page-head.vue







const __exports__ = /*#__PURE__*/exportHelper_default()(page_headvue_type_script_lang_js, [['render',render],['__scopeId',"data-v-d087da92"]])

/* harmony default export */ var page_head = (__exports__);
// CONCATENATED MODULE: ../packages/components/page-head/index.js




page_head.install = function (Vue) {
  Vue.component(page_head.name, page_head);
};

/* harmony default export */ var components_page_head = (page_head);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/course-qrcode/course-qrcode.vue?vue&type=template&id=24de772d&scoped=true


const course_qrcodevue_type_template_id_24de772d_scoped_true_withScopeId = n => (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["pushScopeId"])("data-v-24de772d"),n=n(),Object(external_commonjs_vue_commonjs2_vue_root_Vue_["popScopeId"])(),n)
const course_qrcodevue_type_template_id_24de772d_scoped_true_hoisted_1 = { class: "course-qrcode" }
const course_qrcodevue_type_template_id_24de772d_scoped_true_hoisted_2 = { class: "code-container" }
const course_qrcodevue_type_template_id_24de772d_scoped_true_hoisted_3 = ["src"]
const course_qrcodevue_type_template_id_24de772d_scoped_true_hoisted_4 = { class: "code-tip" }

function course_qrcodevue_type_template_id_24de772d_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", course_qrcodevue_type_template_id_24de772d_scoped_true_hoisted_1, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", course_qrcodevue_type_template_id_24de772d_scoped_true_hoisted_2, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("img", {
        src: $data.qrcode,
        width: "156",
        height: "156"
      }, null, 8, course_qrcodevue_type_template_id_24de772d_scoped_true_hoisted_3)
    ]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", course_qrcodevue_type_template_id_24de772d_scoped_true_hoisted_4, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.qrcodeText), 1)
  ]))
}
// CONCATENATED MODULE: ../packages/components/course-qrcode/course-qrcode.vue?vue&type=template&id=24de772d&scoped=true

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ../node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("c1c3");

// EXTERNAL MODULE: ../node_modules/qrcode/lib/browser.js
var browser = __webpack_require__("f9af");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/course-qrcode/course-qrcode.vue?vue&type=script&lang=js



/* harmony default export */ var course_qrcodevue_type_script_lang_js = ({
  name: 'CourseQrcode',
  props: {
    qrcodeUrl: {
      type: String,
      default: 'https://app-cdn.btclass.cn/phoenix/57279/Fl7MAZIjTsPqenDBwVhJiSXv0ZqT.jpg'
    },
    qrcodeLink: {
      type: String
    },
    qrcodeType: {
      type: String,
      default: 'link'
    },
    qrcodeText: {
      type: String,
      default: '请保存二维码添加公众号'
    }
  },
  data: function data() {
    return {
      qrcode: ''
    };
  },
  watch: {
    qrcodeType: {
      handler: function handler(type) {
        if (type === 'img') {
          this.qrcode = this.qrcodeUrl;
        } else {
          this.getQrcode(this.qrcodeLink);
        }
      },
      immediate: true
    },
    qrcodeLink: {
      handler: function handler(link) {
        this.getQrcode(link);
      } // immediate: true,

    },
    qrcodeUrl: {
      handler: function handler(link) {
        this.qrcode = link;
      },
      immediate: true
    }
  },
  methods: {
    getQrcode: function getQrcode(link) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.$isServer) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (link) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _context.next = 6;
                return browser_default.a.toDataURL(link, {
                  errorCorrectionLevel: "H",
                  // 纠错级别最高
                  width: 132,
                  margin: 0,
                  scale: 1
                });

              case 6:
                url = _context.sent;
                _this.qrcode = url;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
});
// CONCATENATED MODULE: ../packages/components/course-qrcode/course-qrcode.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ../packages/components/course-qrcode/course-qrcode.vue?vue&type=style&index=0&id=24de772d&lang=scss&scoped=true
var course_qrcodevue_type_style_index_0_id_24de772d_lang_scss_scoped_true = __webpack_require__("bd3c");

// CONCATENATED MODULE: ../packages/components/course-qrcode/course-qrcode.vue







const course_qrcode_exports_ = /*#__PURE__*/exportHelper_default()(course_qrcodevue_type_script_lang_js, [['render',course_qrcodevue_type_template_id_24de772d_scoped_true_render],['__scopeId',"data-v-24de772d"]])

/* harmony default export */ var course_qrcode = (course_qrcode_exports_);
// CONCATENATED MODULE: ../packages/components/course-qrcode/index.js




course_qrcode.install = function (Vue) {
  Vue.component(course_qrcode.name, course_qrcode);
};

/* harmony default export */ var components_course_qrcode = (course_qrcode);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/gif-process/gif-process.vue?vue&type=template&id=4435afae&scoped=true


const gif_processvue_type_template_id_4435afae_scoped_true_withScopeId = n => (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["pushScopeId"])("data-v-4435afae"),n=n(),Object(external_commonjs_vue_commonjs2_vue_root_Vue_["popScopeId"])(),n)
const gif_processvue_type_template_id_4435afae_scoped_true_hoisted_1 = { class: "title" }
const gif_processvue_type_template_id_4435afae_scoped_true_hoisted_2 = /*#__PURE__*/ gif_processvue_type_template_id_4435afae_scoped_true_withScopeId(() => /*#__PURE__*/Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("i", { class: "title-icon" }, null, -1))
const gif_processvue_type_template_id_4435afae_scoped_true_hoisted_3 = { class: "text" }
const gif_processvue_type_template_id_4435afae_scoped_true_hoisted_4 = /*#__PURE__*/ gif_processvue_type_template_id_4435afae_scoped_true_withScopeId(() => /*#__PURE__*/Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("i", { class: "title-icon" }, null, -1))
const _hoisted_5 = ["src"]

function gif_processvue_type_template_id_4435afae_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", {
    class: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeClass"])(['gif-process', $props.theme])
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", gif_processvue_type_template_id_4435afae_scoped_true_hoisted_1, [
      gif_processvue_type_template_id_4435afae_scoped_true_hoisted_2,
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("span", gif_processvue_type_template_id_4435afae_scoped_true_hoisted_3, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.title), 1),
      gif_processvue_type_template_id_4435afae_scoped_true_hoisted_4
    ]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("img", {
      src: $props.gifProcess,
      width: "307"
    }, null, 8, _hoisted_5)
  ], 2))
}
// CONCATENATED MODULE: ../packages/components/gif-process/gif-process.vue?vue&type=template&id=4435afae&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/gif-process/gif-process.vue?vue&type=script&lang=js
/* harmony default export */ var gif_processvue_type_script_lang_js = ({
  name: 'GifProcess',
  props: {
    theme: {
      type: String,
      default: 'bt-blue'
    },
    title: {
      type: String,
      default: '操作流程动图展示'
    },
    gifProcess: {
      type: String
    }
  }
});
// CONCATENATED MODULE: ../packages/components/gif-process/gif-process.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ../packages/components/gif-process/gif-process.vue?vue&type=style&index=0&id=4435afae&lang=scss&scoped=true
var gif_processvue_type_style_index_0_id_4435afae_lang_scss_scoped_true = __webpack_require__("7c3c");

// CONCATENATED MODULE: ../packages/components/gif-process/gif-process.vue







const gif_process_exports_ = /*#__PURE__*/exportHelper_default()(gif_processvue_type_script_lang_js, [['render',gif_processvue_type_template_id_4435afae_scoped_true_render],['__scopeId',"data-v-4435afae"]])

/* harmony default export */ var gif_process = (gif_process_exports_);
// CONCATENATED MODULE: ../packages/components/gif-process/index.js




gif_process.install = function (Vue) {
  Vue.component(gif_process.name, gif_process);
};

/* harmony default export */ var components_gif_process = (gif_process);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/gzh-template-new/gzh-template-new.vue?vue&type=template&id=3695f397&scoped=true


const gzh_template_newvue_type_template_id_3695f397_scoped_true_withScopeId = n => (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["pushScopeId"])("data-v-3695f397"),n=n(),Object(external_commonjs_vue_commonjs2_vue_root_Vue_["popScopeId"])(),n)
const gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_1 = { class: "container-wrap" }
const gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_2 = { class: "left" }
const gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_3 = ["src"]
const gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_4 = { class: "gzh-name" }
const gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_5 = { class: "right" }

function gzh_template_newvue_type_template_id_3695f397_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", {
    class: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeClass"])(['gzh-template-new', $props.theme])
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_1, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_2, [
        Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("img", {
          src: $props.accountImage,
          width: "40",
          height: "40"
        }, null, 8, gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_3),
        Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("span", gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_4, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.accountName), 1)
      ]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", gzh_template_newvue_type_template_id_3695f397_scoped_true_hoisted_5, [
        Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("span", {
          class: "copy-btn",
          onClick: _cache[0] || (_cache[0] = $event => (
              $options.dataCopy(
                '.copy-btn',
                $props.accountName,
                '点击复制公众号名称'
              )
            ))
        }, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.copyName), 1)
      ])
    ])
  ], 2))
}
// CONCATENATED MODULE: ../packages/components/gzh-template-new/gzh-template-new.vue?vue&type=template&id=3695f397&scoped=true

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("7e9e");

// EXTERNAL MODULE: ../node_modules/clipboard/dist/clipboard.js
var dist_clipboard = __webpack_require__("ae45");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(dist_clipboard);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/gzh-template-new/gzh-template-new.vue?vue&type=script&lang=js


/* harmony default export */ var gzh_template_newvue_type_script_lang_js = ({
  name: 'GzhTemplateNew',
  props: {
    theme: {
      type: String,
      default: 'bt-blue'
    },
    accountImage: {
      type: String,
      default: 'https://app-cdn.btclass.cn/phoenix/1016133/FqF4q4GnCB05QeeWZgIzXUftCv4i.jpg'
    },
    accountName: {
      type: String,
      default: 'BT学院'
    },
    copyName: {
      type: String,
      default: '一键复制'
    }
  },
  data: function data() {
    var actId;
    var channelId;

    if (this.$route) {
      var _this$$route$query = this.$route.query;
      actId = _this$$route$query.actId;
      channelId = _this$$route$query.channelId;
    }

    return {
      activityId: Number(actId) || 0,
      channelId: Number(channelId) || 0
    };
  },
  methods: {
    openWeixin: function openWeixin() {
      if (this.$isServer) return;
      var openweixin = document.createElement("a");
      openweixin.href = "weixin://";
      openweixin.click();
      openweixin = null;
    },
    // 百度统计记录事件
    pushEvent: function pushEvent(type) {
      if (this.$isServer) return;

      try {
        window._hmt && window._hmt.push(["_trackEvent", "\u6D3B\u52A8-".concat(this.activityId), type, this.channelId]);
      } catch (error) {
        console.error(error);
      }
    },
    dataCopy: function dataCopy(className, _text, recordName) {
      var _this = this;

      if (this.$isServer) return;
      this.pushEvent(recordName);
      var clipboard = new clipboard_default.a(className, {
        action: "copy",
        text: function text() {
          return _text;
        }
      });
      clipboard.on("success", function () {
        _this.$toast("复制成功"); // 释放内存


        clipboard.destroy();

        _this.openWeixin();
      });
      clipboard.on("error", function () {
        // 不支持复制
        console.log("该浏览器不支持自动复制"); // 释放内存

        clipboard.destroy();
      });
    }
  }
});
// CONCATENATED MODULE: ../packages/components/gzh-template-new/gzh-template-new.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ../packages/components/gzh-template-new/gzh-template-new.vue?vue&type=style&index=0&id=3695f397&lang=scss&scoped=true
var gzh_template_newvue_type_style_index_0_id_3695f397_lang_scss_scoped_true = __webpack_require__("9166");

// CONCATENATED MODULE: ../packages/components/gzh-template-new/gzh-template-new.vue







const gzh_template_new_exports_ = /*#__PURE__*/exportHelper_default()(gzh_template_newvue_type_script_lang_js, [['render',gzh_template_newvue_type_template_id_3695f397_scoped_true_render],['__scopeId',"data-v-3695f397"]])

/* harmony default export */ var gzh_template_new = (gzh_template_new_exports_);
// CONCATENATED MODULE: ../packages/components/gzh-template-new/index.js




gzh_template_new.install = function (Vue) {
  Vue.component(gzh_template_new.name, gzh_template_new);
};

/* harmony default export */ var components_gzh_template_new = (gzh_template_new);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/gzh-template-old/gzh-template-old.vue?vue&type=template&id=51150de6&scoped=true


const gzh_template_oldvue_type_template_id_51150de6_scoped_true_withScopeId = n => (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["pushScopeId"])("data-v-51150de6"),n=n(),Object(external_commonjs_vue_commonjs2_vue_root_Vue_["popScopeId"])(),n)
const gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_1 = { class: "gzh-name" }
const gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_2 = { class: "step" }
const gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_3 = {
  class: /*#__PURE__*/Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeClass"])(['step-item'])
}
const gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_4 = { class: "text" }
const gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_5 = {
  key: 0,
  class: "footer"
}
const _hoisted_6 = /*#__PURE__*/ gzh_template_oldvue_type_template_id_51150de6_scoped_true_withScopeId(() => /*#__PURE__*/Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", { class: "help" }, "添加遇到问题？", -1))
const _hoisted_7 = /*#__PURE__*/Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createTextVNode"])("添加客服微信：")
const _hoisted_8 = { class: "wechat" }

function gzh_template_oldvue_type_template_id_51150de6_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", {
    class: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeClass"])(['gzh-template-old', $props.theme])
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_1, "公众号：" + Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.accountName), 1),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", {
      class: "copy-btn",
      onClick: _cache[0] || (_cache[0] = $event => ($options.dataCopy('.copy-btn', $props.accountName, '复制公众号')))
    }, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.copyName), 1),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_2, [
      (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(true), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])(external_commonjs_vue_commonjs2_vue_root_Vue_["Fragment"], null, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["renderList"])($props.processGuideInfo, (step, index) => {
        return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])(external_commonjs_vue_commonjs2_vue_root_Vue_["Fragment"], {
          key: step + index
        }, [
          Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_3, [
            Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("i", {
              class: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeClass"])(['step-icon', `step-icon-${index + 1}`])
            }, null, 2),
            Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_4, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])(step), 1)
          ]),
          (index !== $props.processGuideInfo.length - 1)
            ? (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("span", {
                class: "split-line",
                key: index
              }))
            : Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createCommentVNode"])("", true)
        ], 64))
      }), 128))
    ]),
    ($props.wxAccount)
      ? (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", gzh_template_oldvue_type_template_id_51150de6_scoped_true_hoisted_5, [
          _hoisted_6,
          Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("p", null, [
            _hoisted_7,
            Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("span", _hoisted_8, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.wxAccount), 1),
            Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("span", {
              class: "btn-copy",
              onClick: _cache[1] || (_cache[1] = $event => ($options.dataCopy('.btn-copy', $props.wxAccount, '复制客服微信')))
            }, "复制")
          ])
        ]))
      : Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createCommentVNode"])("", true)
  ], 2))
}
// CONCATENATED MODULE: ../packages/components/gzh-template-old/gzh-template-old.vue?vue&type=template&id=51150de6&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/gzh-template-old/gzh-template-old.vue?vue&type=script&lang=js


/* harmony default export */ var gzh_template_oldvue_type_script_lang_js = ({
  name: 'GzhTemplateOld',
  props: {
    theme: {
      type: String,
      default: 'bt-blue'
    },
    accountName: {
      type: String,
      default: 'BT学院'
    },
    wxAccount: {
      type: String
    },
    copyName: {
      type: String,
      default: '复制公众号名称'
    },
    processGuideInfo: {
      type: Array,
      default: function _default() {
        return ["\u6253\u5F00\n\u5FAE\u4FE1\u641C\u7D22", "\u7C98\u8D34\n\u516C\u4F17\u53F7\u540D\u79F0\n        ", "\u5173\u6CE8\u540E\u70B9\u51FB\n\u300C\u5F00\u901A\u8BFE\u7A0B\u300D", "\u5F00\u901A\n\u300C\u7406\u8D22\u5C0F\u767D\u8425\u300D"];
      }
    }
  },
  data: function data() {
    var actId;
    var channelId;

    if (this.$route) {
      var _this$$route$query = this.$route.query;
      actId = _this$$route$query.actId;
      channelId = _this$$route$query.channelId;
    }

    return {
      activityId: Number(actId) || 0,
      channelId: Number(channelId) || 0
    };
  },
  methods: {
    openWeixin: function openWeixin() {
      if (this.$isServer) return;
      var openweixin = document.createElement("a");
      openweixin.href = "weixin://";
      openweixin.click();
      openweixin = null;
    },
    // 百度统计记录事件
    pushEvent: function pushEvent(type) {
      if (this.$isServer) return;

      try {
        window._hmt && window._hmt.push(["_trackEvent", "\u6D3B\u52A8-".concat(this.activityId), type, this.channelId]);
      } catch (error) {
        console.error(error);
      }
    },
    dataCopy: function dataCopy(className, _text, recordName) {
      var _this = this;

      if (this.$isServer) return;
      this.pushEvent(recordName);
      var clipboard = new clipboard_default.a(className, {
        action: "copy",
        text: function text() {
          return _text;
        }
      });
      clipboard.on("success", function () {
        _this.$toast("复制成功"); // 释放内存


        clipboard.destroy();

        _this.openWeixin();
      });
      clipboard.on("error", function () {
        // 不支持复制
        console.log("该浏览器不支持自动复制"); // 释放内存

        clipboard.destroy();
      });
    }
  }
});
// CONCATENATED MODULE: ../packages/components/gzh-template-old/gzh-template-old.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ../packages/components/gzh-template-old/gzh-template-old.vue?vue&type=style&index=0&id=51150de6&lang=scss&scoped=true
var gzh_template_oldvue_type_style_index_0_id_51150de6_lang_scss_scoped_true = __webpack_require__("fad5");

// CONCATENATED MODULE: ../packages/components/gzh-template-old/gzh-template-old.vue







const gzh_template_old_exports_ = /*#__PURE__*/exportHelper_default()(gzh_template_oldvue_type_script_lang_js, [['render',gzh_template_oldvue_type_template_id_51150de6_scoped_true_render],['__scopeId',"data-v-51150de6"]])

/* harmony default export */ var gzh_template_old = (gzh_template_old_exports_);
// CONCATENATED MODULE: ../packages/components/gzh-template-old/index.js




gzh_template_old.install = function (Vue) {
  Vue.component(gzh_template_old.name, gzh_template_old);
};

/* harmony default export */ var components_gzh_template_old = (gzh_template_old);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/text-process/text-process.vue?vue&type=template&id=83b76498&scoped=true


const text_processvue_type_template_id_83b76498_scoped_true_withScopeId = n => (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["pushScopeId"])("data-v-83b76498"),n=n(),Object(external_commonjs_vue_commonjs2_vue_root_Vue_["popScopeId"])(),n)
const text_processvue_type_template_id_83b76498_scoped_true_hoisted_1 = { class: "title" }
const text_processvue_type_template_id_83b76498_scoped_true_hoisted_2 = /*#__PURE__*/ text_processvue_type_template_id_83b76498_scoped_true_withScopeId(() => /*#__PURE__*/Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("i", { class: "title-icon" }, null, -1))
const text_processvue_type_template_id_83b76498_scoped_true_hoisted_3 = { class: "text" }
const text_processvue_type_template_id_83b76498_scoped_true_hoisted_4 = /*#__PURE__*/ text_processvue_type_template_id_83b76498_scoped_true_withScopeId(() => /*#__PURE__*/Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("i", { class: "title-icon" }, null, -1))
const text_processvue_type_template_id_83b76498_scoped_true_hoisted_5 = { class: "step" }
const text_processvue_type_template_id_83b76498_scoped_true_hoisted_6 = ["data-index"]

function text_processvue_type_template_id_83b76498_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", {
    class: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeClass"])(['text-process', $props.theme])
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", text_processvue_type_template_id_83b76498_scoped_true_hoisted_1, [
      text_processvue_type_template_id_83b76498_scoped_true_hoisted_2,
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("span", text_processvue_type_template_id_83b76498_scoped_true_hoisted_3, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.processTitle), 1),
      text_processvue_type_template_id_83b76498_scoped_true_hoisted_4
    ]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", text_processvue_type_template_id_83b76498_scoped_true_hoisted_5, [
      (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(true), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])(external_commonjs_vue_commonjs2_vue_root_Vue_["Fragment"], null, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["renderList"])($props.steps, (step, index) => {
        return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", {
          class: "step-item",
          key: index,
          "data-index": index + 1
        }, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])(step), 9, text_processvue_type_template_id_83b76498_scoped_true_hoisted_6))
      }), 128))
    ])
  ], 2))
}
// CONCATENATED MODULE: ../packages/components/text-process/text-process.vue?vue&type=template&id=83b76498&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!../packages/components/text-process/text-process.vue?vue&type=script&lang=js
/* harmony default export */ var text_processvue_type_script_lang_js = ({
  name: 'TextProcess',
  props: {
    theme: {
      type: String,
      default: 'bt-blue'
    },
    processTitle: {
      type: String,
      default: '获取听课方式仅需3步'
    },
    steps: {
      type: Array,
      default: function _default() {
        return ['点击“一键复制”按钮并打开微信', '粘贴并搜索【BT学院】，点击关注', '关注后，按照提示加入听课群，预约成功!'];
      }
    }
  }
});
// CONCATENATED MODULE: ../packages/components/text-process/text-process.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ../packages/components/text-process/text-process.vue?vue&type=style&index=0&id=83b76498&lang=scss&scoped=true
var text_processvue_type_style_index_0_id_83b76498_lang_scss_scoped_true = __webpack_require__("9a33");

// CONCATENATED MODULE: ../packages/components/text-process/text-process.vue







const text_process_exports_ = /*#__PURE__*/exportHelper_default()(text_processvue_type_script_lang_js, [['render',text_processvue_type_template_id_83b76498_scoped_true_render],['__scopeId',"data-v-83b76498"]])

/* harmony default export */ var text_process = (text_process_exports_);
// CONCATENATED MODULE: ../packages/components/text-process/index.js




text_process.install = function (Vue) {
  Vue.component(text_process.name, text_process);
};

/* harmony default export */ var components_text_process = (text_process);
// EXTERNAL MODULE: ../packages/assets/images/page-head.png
var images_page_head = __webpack_require__("373b");
var page_head_default = /*#__PURE__*/__webpack_require__.n(images_page_head);

// EXTERNAL MODULE: ../packages/assets/images/gzh-new.png
var gzh_new = __webpack_require__("8ec5");
var gzh_new_default = /*#__PURE__*/__webpack_require__.n(gzh_new);

// EXTERNAL MODULE: ../packages/assets/images/text-process.png
var images_text_process = __webpack_require__("a9c0");
var text_process_default = /*#__PURE__*/__webpack_require__.n(images_text_process);

// EXTERNAL MODULE: ../packages/assets/images/gif-process.png
var images_gif_process = __webpack_require__("a16c");
var gif_process_default = /*#__PURE__*/__webpack_require__.n(images_gif_process);

// EXTERNAL MODULE: ../packages/assets/images/qrcode.png
var qrcode = __webpack_require__("17c4");
var qrcode_default = /*#__PURE__*/__webpack_require__.n(qrcode);

// EXTERNAL MODULE: ../packages/assets/images/gzh-old.png
var gzh_old = __webpack_require__("3808");
var gzh_old_default = /*#__PURE__*/__webpack_require__.n(gzh_old);

// CONCATENATED MODULE: ../packages/lib/modularMap.js








var modularMap = [{
  name: '页头',
  code: 'PAGE_HEAD',
  image: page_head_default.a,
  componentName: 'page-head',
  formItems: [{
    label: '页头文案',
    key: 'pageTitle',
    component: 'el-input',
    componentProps: {
      placeholder: '恭喜购课成功'
    }
  }, {
    label: '引导文案',
    key: 'pageSubTitle',
    component: 'el-input',
    componentProps: {
      placeholder: '请加班班进群学习'
    }
  }]
}, {
  name: '新公众号模版',
  code: 'GZH_TEMPLATE_NEW',
  image: gzh_new_default.a,
  componentName: 'gzh-template-new',
  formItems: [{
    label: '公众号名称',
    key: 'accountName',
    component: 'el-input',
    componentProps: {
      placeholder: '请输入，15字以内'
    },
    rules: [{
      required: true,
      message: '请输入公众号名称'
    }]
  }, {
    label: '公众号图片',
    key: 'accountImage',
    isCustomer: true,
    imagePicker: true
  }, {
    label: '按钮文案',
    key: 'copyName',
    component: 'el-input',
    componentProps: {
      placeholder: '一键复制'
    }
  }]
}, {
  name: '文字操作流程',
  code: 'TEXT_PROCESS',
  image: text_process_default.a,
  componentName: 'text-process',
  formItems: [{
    label: '获取听课方式引导文案',
    key: 'processTitle',
    required: true,
    component: 'el-input',
    componentProps: {
      placeholder: '获取听课方式仅需3步'
    }
  }, {
    label: '添加步骤说明',
    key: 'steps',
    isCustomer: true,
    rules: [{
      required: true,
      validator: function validator(_, value, callback) {
        if (Array.isArray(value)) {
          if (value.length === 0) {
            callback('请添加步骤说明');
          } else if (value.some(function (item) {
            return !item;
          })) {
            callback('请添加步骤说明');
          } else {
            callback();
          }
        } else {
          callback('请添加步骤说明');
        }
      }
    }]
  }]
}, {
  name: '动图操作流程',
  code: 'GIF_PROCESS',
  image: gif_process_default.a,
  componentName: 'gif-process',
  formItems: [{
    label: '上传操作流程动图',
    key: 'gifProcess',
    isCustomer: true,
    imagePicker: true
  }]
}, {
  name: '开课二维码',
  code: 'COURSE_QRCODE',
  image: qrcode_default.a,
  componentName: 'course-qrcode',
  formItems: [{
    label: '二维码文案',
    key: 'qrcodeText',
    component: 'el-input',
    componentProps: {
      placeholder: '请输入，16字以内'
    }
  }, {
    label: '选择二维码填充类型',
    key: 'qrcodeType',
    isCustomer: true,
    imagePicker: true,
    tips: '选择链接后，会自动生成对应的二维码',
    rules: [{
      required: true,
      message: '请选择二维码填充类型'
    }]
  }]
}, {
  name: '老公众号模版',
  code: 'GZH_TEMPLATE_OLD',
  image: gzh_old_default.a,
  componentName: 'gzh-template-old',
  formItems: [{
    label: '公众号名称',
    key: 'accountName',
    component: 'el-input',
    componentProps: {
      placeholder: '请输入，15字以内'
    },
    rules: [{
      required: true,
      message: '请输入公众号名称'
    }]
  }, {
    label: '操作步骤',
    key: 'processGuideInfo',
    isCustomer: true,
    rules: [{
      required: true,
      validator: function validator(_, value, callback) {
        if (Array.isArray(value)) {
          if (value.some(function (item) {
            return !item;
          })) {
            callback('请输入操作步骤');
          } else {
            callback();
          }
        } else {
          callback('请输入操作步骤');
        }
      }
    }]
  }, {
    label: '客服微信号',
    key: 'wxAccount',
    component: 'el-input',
    componentProps: {
      placeholder: '请输入客服微信号'
    }
  }]
}];
/* harmony default export */ var lib_modularMap = (modularMap);
// CONCATENATED MODULE: ../packages/index.js














var components = [components_page_head, components_course_qrcode, components_gif_process, components_gzh_template_new, components_gzh_template_old, components_text_process];

var install = function install(Vue) {
  if (install.installed) return;
  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ var packages_0 = (_objectSpread2({
  install: install,
  modularMap: lib_modularMap
}, components));
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (packages_0);



/***/ }),

/***/ "fd48":
/***/ (function(module, exports) {

function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  var hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  var hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  var margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0 ? 4 : options.margin

  var width = options.width && options.width >= 21 ? options.width : undefined
  var scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  var scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  var size = qr.modules.size
  var data = qr.modules.data
  var scale = exports.getScale(size, opts)
  var symbolSize = Math.floor((size + opts.margin * 2) * scale)
  var scaledMargin = opts.margin * scale
  var palette = [opts.color.light, opts.color.dark]

  for (var i = 0; i < symbolSize; i++) {
    for (var j = 0; j < symbolSize; j++) {
      var posDst = (i * symbolSize + j) * 4
      var pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        var iSrc = Math.floor((i - scaledMargin) / scale)
        var jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}


/***/ }),

/***/ "fdd5":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5860");
var isCallable = __webpack_require__("3c61");
var store = __webpack_require__("3283");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ })

/******/ });
});
//# sourceMappingURL=index.umd.js.map